var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"header text-center"},[_c('h3',{staticClass:"title"},[_vm._v("Logging Out")])])])}]

export { render, staticRenderFns }